import layout from './SearchListViewView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import SearchListViewViewModel from '@/ViewModels/Views/SearchListViewViewModel';

export default class SearchListViewView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(protected viewModel: SearchListViewViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        ko.applyBindingsToNode(this.view[0], {
            hotkey: {
                shortcut: 'esc',
                handler: () => {
                    this.viewModel.cancel.onClick();
                },
                isGlobal: false
            }
        });
        return this.view;
    }
}

ComponentManager.setView('SearchListViewView', SearchListViewView, 'RADPresentation.HTMLClient.DefaultViewExtensions');